import { useSortable } from '@dnd-kit/sortable';
import { CSS } from '@dnd-kit/utilities';
import type { CSSProperties, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { ReportPromptDragHandle } from './ReportPromptDragHandle';

interface SortableReportPromptGroupProps {
    id: string;
    reorderLabel: string;
    reorderable: boolean;
    children: ReactNode;
}

export function SortableReportPromptGroup({
    id,
    reorderLabel,
    reorderable,
    children,
}: SortableReportPromptGroupProps) {
    const {
        attributes,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition,
        isDragging,
    } = useSortable({ id, disabled: !reorderable });

    const style: CSSProperties = {
        transform: CSS.Translate.toString(transform),
        transition,
    };

    return (
        <div
            ref={setNodeRef}
            style={style}
            className={cn(
                'group/report-prompt relative rounded-[5px]',
                isDragging && 'z-10 opacity-60',
            )}
        >
            {reorderable && (
                <ReportPromptDragHandle
                    ref={setActivatorNodeRef}
                    label={reorderLabel}
                    testId={`report-prompt-drag-handle-${id}`}
                    attributes={attributes}
                    listeners={listeners}
                />
            )}
            {children}
        </div>
    );
}
